import React from 'react'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'

import 'firebaseui/dist/firebaseui.css'
import 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/messaging'

import Title from '../../atomics/Typography/Title'
import Text from '../../atomics/Typography/Text'

const Divider = styled('div')`
  height: 1rem;
`

const TitleLogin = styled(Title)`
  color: ${({ iserror, theme }) =>
    iserror === 'true'
      ? theme.palette.error.main
      : theme.palette.text.primary};
  text-align: left;
  line-height: 24px;
  font-size: 20px;
`

const TextInfo = styled(Text)`
  line-height: 24px;
  font-size: 18px;
  a {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.secondary.main};
    &:hover {
      color: ${({ theme }) => theme.palette.secondary.dark};
    }
  }
`

const ToMail = styled('a')`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.secondary.main};
  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }
`

const idle = {
  title: 'Iniciar sesión',
  subtitle:
    'Para registrarse a la aplicación BackOffice de Kitchen Center y/o habilitar permisos debe contactar:  '
}

const error = {
  title: 'Error de Acceso',
  subtitle:
    'Su usuario no se encuentra habilitado, contacte con el administrador indicando el problema:  '
}

export const MessageTemplate = ({ title, subtitle, iserror }) => {
  const ccEmails = [
    'avega@kitchencenter.cl',
    'jhernandez@kitchencenter.cl'
  ]
  const emails = [
    'soportesap@kitchencenter.cl',
    'fbeneventi@kitchencenter.cl'
  ]
  const subject = '[SEGURIDAD] Error acceso BackOffice'

  const toEmailsString = emails.join(',')
  const ccEmailsString = ccEmails.join(',')
  const mailtoLink = `mailto:${toEmailsString}?cc=${ccEmailsString}&subject=${encodeURIComponent(
    subject
  )}`

  return (
    <>
      <TitleLogin iserror={String(iserror)} variant="h2">
        {title}
      </TitleLogin>
      <Divider />
      <Divider />

      <TextInfo>
        {subtitle}
        <ToMail href={mailtoLink}>fbeneventi@kitchencenter.cl</ToMail>
      </TextInfo>
    </>
  )
}
export const Message = ({ errorText }) => (
  <MessageTemplate
    iserror={!isEmpty(errorText)}
    title={!isEmpty(errorText) ? error.title : ''}
    subtitle={!isEmpty(errorText) ? error.subtitle : idle.subtitle}
    abstract={!isEmpty(errorText) ? error.abstract : idle.abstract}
  />
)
export default Message
